import React, { useState } from "react";
import { CaseWithImages, ImageAndQuery } from "../models";
import { LoggedInUser } from "../permissions";
import styled from "styled-components";
import { Box, Table } from "@blasterjs/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus, faCircleMinus } from "@fortawesome/free-solid-svg-icons";

interface Props {
  readonly loggedInUser: LoggedInUser;
  readonly histoCase: CaseWithImages | null;
  readonly selectedImage: ImageAndQuery | null;
  readonly studyName: string | null;
}

const DetailsPanel = styled.div`
  background-color: #f0f2f5;
  width: 100%;
  border-radius: 8px;
  padding: 8px;
  gap: 4px;
  margin-bottom: 1rem;
`;

const DetailPanelHeader = styled.p`
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0%;
  display: inline;
  word-break: normal;
`;

const DetailPanelData = styled.p`
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0%;
  display: inline;
  margin-left: 0.5rem;
  word-break: break-all;
`;

const SidebarPanelCaseDetails = ({ loggedInUser, histoCase, selectedImage, studyName }: Props) => {
  const [detailsExpanded, setDetailsExpanded] = useState(false);

  const caseDetails = [
    {
      header: "Histo Procedure ID",
      data: histoCase ? histoCase.caseWithStatus.histoProcedureId : null,
      crCanView: true,
      displayCollapsed: true
    },
    {
      header: "Endo Procedure ID",
      data: histoCase ? histoCase.caseWithStatus.procId : null,
      crCanView: true,
      displayCollapsed: true
    },
    {
      header: "Accession",
      data: selectedImage ? selectedImage.image.accessionNumber : null,
      crCanView: true,
      displayCollapsed: false
    },
    {
      header: "Subject ID",
      data:
        histoCase && "subjectId" in histoCase.caseWithStatus
          ? histoCase.caseWithStatus.subjectId
          : null,
      crCanView: false,
      displayCollapsed: false
    },
    {
      header: "Site ID",
      data:
        histoCase && "siteId" in histoCase.caseWithStatus ? histoCase.caseWithStatus.siteId : null,
      crCanView: false,
      displayCollapsed: false
    },
    {
      header: "Visit ID",
      data:
        histoCase && "visitId" in histoCase.caseWithStatus
          ? histoCase.caseWithStatus.visitId
          : null,
      crCanView: false,
      displayCollapsed: false
    },
    {
      header: "Study Name",
      data: studyName ? studyName : null,
      crCanView: true,
      displayCollapsed: true
    }
  ];

  const generateCaseSummaryTabInfo = () => {
    return caseDetails.map((detail, index) => {
      if (detailsExpanded || (!detailsExpanded && detail.displayCollapsed)) {
        if ((loggedInUser.isCR() && detail.crCanView) || !loggedInUser.isCR()) {
          return (
            <React.Fragment key={index}>
              <DetailPanelHeader>{detail.header.replace(/ /g, "\u00A0")}:</DetailPanelHeader>
              <DetailPanelData>{detail.data ? detail.data : ""}</DetailPanelData>
              &nbsp;
              <br />
            </React.Fragment>
          );
        }
      }
    });
  };

  return (
    <DetailsPanel>
      <Table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td>
              <Box>
                <div>{generateCaseSummaryTabInfo()}</div>
              </Box>
            </td>
            <td style={{ paddingRight: "0px", marginRight: "0px", textAlign: "right" }}>
              {detailsExpanded ? (
                <Box onClick={() => setDetailsExpanded(false)} style={{ cursor: "pointer" }}>
                  <FontAwesomeIcon
                    icon={faCircleMinus}
                    style={{ textAlign: "right", color: "#3D3E40", marginLeft: "1rem" }}
                  />
                </Box>
              ) : (
                <Box onClick={() => setDetailsExpanded(true)} style={{ cursor: "pointer" }}>
                  <FontAwesomeIcon
                    icon={faCirclePlus}
                    style={{ textAlign: "right", color: "#3D3E40", marginLeft: "1rem" }}
                  />
                </Box>
              )}
            </td>
          </tr>
        </tbody>
      </Table>
    </DetailsPanel>
  );
};

export default SidebarPanelCaseDetails;
